/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { useMapGetter } from 'dashboard/composables/store.js';

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  /**
   * Replaces "Chatwoot" (any casing) in text with the installation name from
   * global config.
   *
   * NOOVI: quando o super admin limpa "Installation Name" o valor vai a NULL e o
   * early-return antigo devolvia o texto CRU — o rodapé do widget passava a exibir
   * "Powered by Chatwoot" para o cliente final de todos os tenants, exatamente o
   * oposto do que o operador pediu. Caímos primeiro em BRAND_NAME e, sem nenhuma
   * marca configurada, removemos a menção em vez de vazá-la. (whitelabel-brand-fallback)
   * @param {string} text - The text to process
   * @returns {string} - Text with "Chatwoot" replaced by the configured brand
   */
  const replaceInstallationName = text => {
    if (!text) return text;

    const brandName =
      globalConfig.value?.installationName || globalConfig.value?.brandName;
    if (brandName) return text.replace(/chatwoot/gi, brandName);

    const stripped = text.replace(/chatwoot/gi, '');
    if (stripped === text) return text;

    return stripped.replace(/\s{2,}/g, ' ').trim();
  };

  return {
    replaceInstallationName,
  };
}
